
import { WorldCity } from '../types';

// Expansión de Venezuela - 70 ciudades adicionales
export const venezuelaAdditionalCities: WorldCity[] = [
  { name: 'Maracaibo', slug: 'maracaibo', population: 1906205 },
  { name: 'Valencia', slug: 'valencia-venezuela', population: 1827165 },
  { name: 'Barquisimeto', slug: 'barquisimeto', population: 1171043 },
  { name: 'Ciudad Guayana', slug: 'ciudad-guayana', population: 877547 },
  { name: 'Maracay', slug: 'maracay', population: 955362 },
  { name: 'Maturín', slug: 'maturin', population: 542259 },
  { name: 'Ciudad Bolívar', slug: 'ciudad-bolivar', population: 422542 },
  { name: 'Punto Fijo', slug: 'punto-fijo', population: 342075 },
  { name: 'Cumana', slug: 'cumana', population: 358919 },
  { name: 'Mérida', slug: 'merida-venezuela', population: 345489 },
  { name: 'Barcelona', slug: 'barcelona-venezuela', population: 424257 },
  { name: 'Cabimas', slug: 'cabimas', population: 263056 },
  { name: 'Turmero', slug: 'turmero', population: 184865 },
  { name: 'Barinas', slug: 'barinas', population: 370000 },
  { name: 'San Cristóbal', slug: 'san-cristobal', population: 263765 },
  { name: 'Acarigua', slug: 'acarigua', population: 208496 },
  { name: 'Valera', slug: 'valera', population: 154574 },
  { name: 'Guanare', slug: 'guanare', population: 108629 },
  { name: 'Carúpano', slug: 'carupano', population: 173877 },
  { name: 'Los Teques', slug: 'los-teques', population: 140617 },
  { name: 'Cagua', slug: 'cagua', population: 98140 },
  { name: 'Guacara', slug: 'guacara', population: 178000 },
  { name: 'Puerto La Cruz', slug: 'puerto-la-cruz', population: 432000 },
  { name: 'San Felipe', slug: 'san-felipe', population: 90000 },
  { name: 'Porlamar', slug: 'porlamar', population: 85000 },
  { name: 'El Tigre', slug: 'el-tigre', population: 147000 },
  { name: 'Calabozo', slug: 'calabozo', population: 117000 },
  { name: 'Valle de La Pascua', slug: 'valle-de-la-pascua', population: 99000 },
  { name: 'Zaraza', slug: 'zaraza', population: 45000 },
  { name: 'San Juan de los Morros', slug: 'san-juan-de-los-morros', population: 87000 },
  { name: 'Coro', slug: 'coro', population: 195227 },
  { name: 'La Guaira', slug: 'la-guaira', population: 32000 },
  { name: 'Catia La Mar', slug: 'catia-la-mar', population: 45000 },
  { name: 'Maiquetía', slug: 'maiquetia', population: 25000 },
  { name: 'Ocumare del Tuy', slug: 'ocumare-del-tuy', population: 67000 },
  { name: 'Guarenas', slug: 'guarenas', population: 218000 },
  { name: 'Guatire', slug: 'guatire', population: 191000 },
  { name: 'Charallave', slug: 'charallave', population: 122000 },
  { name: 'Santa Teresa del Tuy', slug: 'santa-teresa-del-tuy', population: 95000 },
  { name: 'Cúa', slug: 'cua', population: 124000 },
  { name: 'Altagracia de Orituco', slug: 'altagracia-de-orituco', population: 54000 },
  { name: 'San Sebastián', slug: 'san-sebastian', population: 87000 },
  { name: 'Villa de Cura', slug: 'villa-de-cura', population: 89000 },
  { name: 'Cabudare', slug: 'cabudare', population: 173000 },
  { name: 'El Tocuyo', slug: 'el-tocuyo', population: 65000 },
  { name: 'Quíbor', slug: 'quibor', population: 67000 },
  { name: 'Carora', slug: 'carora', population: 89000 },
  { name: 'Duaca', slug: 'duaca', population: 56000 },
  { name: 'Sarare', slug: 'sarare', population: 34000 },
  { name: 'Ciudad Ojeda', slug: 'ciudad-ojeda', population: 128000 },
  { name: 'Lagunillas', slug: 'lagunillas', population: 67000 },
  { name: 'Santa Rita', slug: 'santa-rita', population: 45000 },
  { name: 'Bachaquero', slug: 'bachaquero', population: 23000 },
  { name: 'Bobures', slug: 'bobures', population: 34000 },
  { name: 'Machiques', slug: 'machiques', population: 78000 },
  { name: 'La Fría', slug: 'la-fria', population: 56000 },
  { name: 'Elorza', slug: 'elorza', population: 23000 },
  { name: 'Bruzual', slug: 'bruzual', population: 34000 },
  { name: 'Sabaneta', slug: 'sabaneta', population: 45000 },
  { name: 'Socopó', slug: 'socopo', population: 56000 },
  { name: 'Santa Bárbara', slug: 'santa-barbara', population: 67000 },
  { name: 'Barinitas', slug: 'barinitas', population: 34000 },
  { name: 'Ciudad Bolivia', slug: 'ciudad-bolivia', population: 45000 },
  { name: 'Libertad', slug: 'libertad', population: 34000 },
  { name: 'Tucupita', slug: 'tucupita', population: 78000 },
  { name: 'Upata', slug: 'upata', population: 67000 },
  { name: 'Tumeremo', slug: 'tumeremo', population: 45000 },
  { name: 'El Callao', slug: 'el-callao', population: 34000 },
  { name: 'Caicara del Orinoco', slug: 'caicara-del-orinoco', population: 56000 },
  { name: 'Puerto Ayacucho', slug: 'puerto-ayacucho', population: 98000 },
  { name: 'San Fernando de Apure', slug: 'san-fernando-de-apure', population: 67000 },
  { name: 'Biruaca', slug: 'biruaca', population: 45000 },
  { name: 'Achaguas', slug: 'achaguas', population: 34000 },
  { name: 'Mantecal', slug: 'mantecal', population: 23000 }
];

export const venezuelaExpanded = {
  code: 'VE',
  name: 'Venezuela',
  slug: 'venezuela',
  population: 28435940,
  topCities: [
    { name: 'Caracas', slug: 'caracas', population: 2935744 },
    ...venezuelaAdditionalCities
  ]
};
